/** Flow 8 — Aide photo (simulation, no backend, no external API) */

export const FLOW8_TITLE = "Flow 8 — Aide photo";

export const FLOW8_STEPS = [
  "Demande d'aide",
  "Lecture de la photo",
  "Aide guidée",
  "Résumé visuel",
  "Compréhension",
];

export const ASK_MESSAGE =
  "Tu bloques sur un exercice ? Envoie une photo, ou dis-moi ce que tu ne comprends pas.";

export const READ_MESSAGE = "Parfait ! Je regarde ta photo avec toi.";

export const PROMPT_MESSAGE =
  "La matière est les maths, et ta page parle de l'effet de la taille d'un échantillon sur la marge d'erreur. Qu'est-ce que tu ne comprends pas ?";

export const BLUR_MESSAGE =
  "La photo est difficile à lire. Envoie-en une plus nette, ou écris la formule : je ne vais pas inventer l'énoncé.";

export const IDEA_MESSAGE =
  "L'idée principale est simple : plus on interroge de personnes, plus le résultat est précis. Imagine qu'un sondage trouve que 30 % des élèves de ton école aiment les maths. Ce 30 % n'est pas parfait, puisqu'on n'a pas interrogé toute l'école. Voici ce que ta page montre.";

export const CURVE_MESSAGE =
  "Avec 100 élèves, l'estimation de 30 % a une marge de 7,54 points. Avec 1 000 élèves, elle tombe à 2,38 points. La courbe descend vite au début, puis de plus en plus lentement. Pour rendre le sondage plus précis, qu'est-ce qu'on devrait faire ?";

export const CHOICE_HINT =
  "Pas tout à fait. Regarde le tableau : quand le nombre d'élèves augmente, la marge baisse. Réessaie.";

export const EXACT_MESSAGE =
  "Exactement ! Plus l'échantillon est grand, plus la marge d'erreur diminue, et le gain de précision devient ensuite plus faible. On peut regarder la formule avec la racine carrée, si c'est cette partie qui te pose problème.";

export const FORMULA_MESSAGE =
  "On reprend la formule de ta page : E = 1,645 × √(p̂(1 − p̂) / n). E est la marge cherchée, 1,645 correspond à une confiance de 90 %, p̂ vaut 0,30 et n est le nombre de personnes.";

export const TRY_MESSAGE =
  "Avec 100 personnes, le calcul vérifié donne E ≈ 0,0754, soit 7,54 %. À toi, avec 400 personnes : combien donne 0,21 ÷ 400 ?";

export const DIV_HINT =
  "Pas tout à fait. 0,21 divisé par 400 est beaucoup plus petit que 0,21 divisé par 100. Réessaie.";

export const DIV_OK =
  "Oui, 0,000525. Avec 400 personnes, la marge tombe à environ 3,77 %. La formule est la partie complexe, alors je prépare une seule image pour la garder lisible.";

export const FICHE_MESSAGE =
  "Voici cette image. Elle reprend la formule, le 7,54 % et le tableau de ta photo.";

export const AFTER_MESSAGE =
  "Dis-moi si tu as compris, si tu veux un autre exemple, ou si tu préfères un tuteur.";

export const UNDERSTOOD_MESSAGE =
  "Bravo. Tu peux refaire une étape sans aide : calcule 0,40 × 0,60. Je note la marge d'erreur comme comprise, et tu peux revenir à ton plan.";

export const AGAIN_MESSAGE =
  "On peut reprendre un exemple avec p̂ = 0,50 et n = 100. La marge y est plus grande, et la fiche reste dans la conversation.";

export const TUTOR_MESSAGE =
  "C'est noté. Un tuteur peut reprendre cet exercice avec toi. En attendant, la fiche reste dans la conversation.";

export const EXTRACT_ROWS = [
  ["Matière", "Maths"],
  ["Thème", "Marge d'erreur"],
  ["Idée", "Taille de l'échantillon"],
  ["Proportion", "30 %"],
  ["Confiance", "90 %"],
];

export const MARGIN_ROWS = [
  ["100 élèves", "± 7,54 %"],
  ["400 élèves", "± 3,77 %"],
  ["1 000 élèves", "± 2,38 %"],
  ["4 000 élèves", "± 1,19 %"],
];

export const CALC_ROWS = [
  ["1 − 0,30", "0,70"],
  ["0,30 × 0,70", "0,21"],
  ["0,21 / 100", "0,0021"],
  ["√0,0021", "≈ 0,04583"],
  ["× 1,645", "≈ 0,0754"],
  ["Marge E", "7,54 %"],
];

export function flow8DisplayIndex(flowStep) {
  if (flowStep <= 0 || flowStep === 90) return 0;
  if (flowStep === 1) return 1;
  if (flowStep <= 5) return 2;
  if (flowStep <= 6) return 3;
  return 4;
}

export const FLOW8_REPLIES = {
  ask: [
    { id: "f8-add", label: "Ajouter une photo", primary: true },
    { id: "f8-pic-marge", label: "Photo : sondage", primary: false },
    { id: "f8-pic-pythagore", label: "Photo : triangle", primary: false },
    { id: "f8-pic-phrase", label: "Photo : phrase", primary: false },
  ],
  read: [
    { id: "f8-lost", label: "Je ne comprends pas", primary: true },
    { id: "f8-formula", label: "C'est le calcul et la formule", primary: false },
    { id: "f8-blur", label: "La photo est floue", primary: false },
  ],
  retry: [
    { id: "f8-add", label: "Ajouter une photo", primary: true },
    { id: "f8-pic-marge", label: "Photo : sondage", primary: false },
    { id: "f8-pic-pythagore", label: "Photo : triangle", primary: false },
    { id: "f8-pic-phrase", label: "Photo : phrase", primary: false },
  ],
  choice: [
    { id: "f8-b", label: "B. Interroger plus de personnes", primary: true },
    { id: "f8-a", label: "A. Interroger moins de personnes", primary: false },
    { id: "f8-c", label: "C. Toujours interroger 100 personnes", primary: false },
  ],
  next: [{ id: "f8-formula", label: "C'est le calcul et la formule", primary: true }],
  divide: [
    { id: "f8-div", label: "0,000525", primary: true },
    { id: "f8-div-mid", label: "0,00525", primary: false },
    { id: "f8-div-hi", label: "0,0525", primary: false },
  ],
  result: [
    { id: "f8-visual", label: "Fais moi un résumé visuel", primary: true },
    { id: "f8-done", label: "J'ai compris", primary: false },
  ],
  after: [
    { id: "f8-done", label: "J'ai compris", primary: true },
    { id: "f8-more", label: "Encore un exemple", primary: false },
    { id: "f8-tutor", label: "Je veux un tuteur", primary: false },
  ],
  bridge: [{ id: "f8-start", label: "J'ai besoin d'aide", primary: true }],
};

export const PYTHAGORE_REPLIES = {
  read: [
    { id: "f8-lost", label: "Je ne comprends pas", primary: true },
    { id: "f8-formula", label: "C'est la formule", primary: false },
    { id: "f8-blur", label: "La photo est floue", primary: false },
  ],
  choice: [
    { id: "f8-p-ok", label: "25", primary: true },
    { id: "f8-p-bad", label: "7", primary: false },
    { id: "f8-p-bad2", label: "12", primary: false },
  ],
  next: [{ id: "f8-formula", label: "C'est la formule", primary: true }],
  divide: [
    { id: "f8-p-sum", label: "100", primary: true },
    { id: "f8-p-sum-bad", label: "14", primary: false },
    { id: "f8-p-sum-bad2", label: "48", primary: false },
  ],
};

export const PHRASE_REPLIES = {
  read: [
    { id: "f8-lost", label: "Je ne comprends pas", primary: true },
    { id: "f8-verb", label: "C'est le verbe", primary: false },
    { id: "f8-blur", label: "La photo est floue", primary: false },
  ],
  choice: [
    { id: "f8-s-ok", label: "Le petit chat noir", primary: true },
    { id: "f8-s-verb", label: "dort", primary: false },
    { id: "f8-s-place", label: "le canapé", primary: false },
  ],
  next: [{ id: "f8-verb", label: "C'est le verbe", primary: true }],
};

export const UNKNOWN_REPLIES = {
  read: [
    { id: "f8-as-marge", label: "C'est le sondage", primary: true },
    { id: "f8-as-pythagore", label: "C'est le triangle", primary: false },
    { id: "f8-as-phrase", label: "C'est la phrase", primary: false },
    { id: "f8-as-other", label: "Autre chose", primary: false },
  ],
};

const COPY = {
  marge: {
    prompt: PROMPT_MESSAGE,
    idea: IDEA_MESSAGE,
    curve: CURVE_MESSAGE,
    choiceHint: CHOICE_HINT,
    exact: EXACT_MESSAGE,
    formula: FORMULA_MESSAGE,
    try: TRY_MESSAGE,
    divHint: DIV_HINT,
    divOk: DIV_OK,
    fiche: FICHE_MESSAGE,
    understood: UNDERSTOOD_MESSAGE,
    again: AGAIN_MESSAGE,
    subject: "Maths",
  },
  pythagore: {
    prompt:
      "La matière est les maths, et ta page montre un triangle rectangle de 3 cm et 4 cm. On cherche l'hypoténuse. Qu'est-ce que tu ne comprends pas ?",
    idea:
      "L'angle droit est entre les côtés de 3 cm et de 4 cm. On ne les additionne pas. On élève chaque côté au carré : 3² = 9 et 4² = 16. Combien vaut 9 + 16 ?",
    curve: "Combien vaut 3² + 4² ?",
    choiceHint: "Pas tout à fait. 3 + 4 et 3 × 4 ne sont pas le calcul du carré. 3² = 9 et 4² = 16. Additionne ces deux carrés.",
    exact:
      "Exactement, 25. La racine de 25 est 5, donc l'hypoténuse mesure 5 cm. On peut regarder la formule, si c'est elle qui bloque.",
    formula:
      "La formule de ta page est a² + b² = c². a et b sont les côtés de l'angle droit, c est l'hypoténuse. Avec 3 et 4, on obtient 9 + 16 = 25, et 25 est le carré de 5.",
    try: "À toi. Les côtés de l'angle droit mesurent 6 cm et 8 cm. Combien vaut 6² + 8² ?",
    divHint: "Pas tout à fait. 6² = 36 et 8² = 64. Additionne les carrés, sans additionner 6 et 8.",
    divOk:
      "Oui, 100. L'hypoténuse mesure 10 cm, puisque 10² = 100. La formule est la partie à garder, alors je prépare une seule image.",
    fiche: "Voici cette image. Elle reprend a² + b² = c², le triangle 3-4-5 et l'exemple 6-8-10.",
    understood: "Bravo. Tu peux refaire une étape sans aide : calcule 5² + 12². Je note Pythagore comme compris.",
    again: "On peut reprendre un triangle de 5 cm et 12 cm. L'hypoténuse vaut 13 cm, et l'image reste dans la conversation.",
    subject: "Maths",
  },
  phrase: {
    prompt:
      "La matière est le français, et ta page montre la phrase « Le petit chat noir dort sur le canapé. » Qu'est-ce que tu ne comprends pas ?",
    idea:
      "La phrase dit qui fait l'action, puis l'action. Quel groupe est le sujet, celui qui dort ?",
    curve: "Quel groupe est le sujet de la phrase ?",
    choiceHint: "Pas tout à fait. « dort » est l'action, et « le canapé » est l'endroit. Le sujet est celui qui fait l'action.",
    exact: "Exactement. « Le petit chat noir » est le sujet. Le verbe, c'est l'action.",
    formula: "Dans cette phrase, le verbe est « dort ». Il dit l'action du chat. Il n'y a pas de formule à dessiner.",
    try: "Le verbe est « dort ». Tu veux le nommer, ou tu as compris la phrase ?",
    divHint: "Le verbe est le mot de l'action. Dans ta phrase, ce n'est ni le chat ni le canapé.",
    divOk: "Oui. Le sujet est « le petit chat noir », et le verbe est « dort ».",
    fiche: "Pas d'image de formule pour cette phrase. Le sujet est « le petit chat noir », et le verbe est « dort ».",
    understood: "Bravo. Tu peux reprendre la phrase et entourer le verbe seul. Je note cette phrase comme comprise.",
    again: "On peut reprendre « La petite chatte grise joue dans le jardin. » Le sujet est « la petite chatte grise ».",
    subject: "Français",
  },
  unknown: {
    prompt:
      "Je vois ta photo, mais je ne reconnais pas la page. Cette démo lit trois exercices : le sondage, le triangle, ou la phrase. Laquelle est-ce ?",
    idea:
      "Je ne vais pas inventer l'énoncé à partir de cette photo. Dis-moi la matière, ou choisis une des trois pages d'exemple.",
    curve: "Choisis une des trois pages, ou écris la matière.",
    choiceHint: "Choisis le sondage, le triangle ou la phrase, ou écris la matière en un mot.",
    exact: "D'accord. Je ne dessine pas de formule tant que la page n'est pas l'un des trois exercices.",
    formula: "Je ne vais pas inventer une formule pour une page que je ne reconnais pas.",
    try: "Écris la matière, ou choisis une page d'exemple.",
    divHint: "Choisis une des trois pages d'exemple.",
    divOk: "Je garde ta photo. Choisis l'exercice qui correspond, et on reprend dessus.",
    fiche: "Pas d'image tant que l'exercice n'est pas reconnu.",
    understood: "C'est noté. Quand tu as la page du sondage, du triangle ou de la phrase, renvoie-la.",
    again: "Tu peux choisir une des trois photos d'exemple.",
    subject: "—",
  },
};

export function helpCopy(item, field) {
  const pack = COPY[item] || COPY.marge;
  return pack[field] || COPY.marge[field];
}

export function helpSubject(item) {
  return (COPY[item] || COPY.unknown).subject;
}

export function repliesFor(item, slot) {
  if (item === "pythagore" && PYTHAGORE_REPLIES[slot]) return PYTHAGORE_REPLIES[slot];
  if (item === "phrase" && PHRASE_REPLIES[slot]) return PHRASE_REPLIES[slot];
  if (item === "unknown" && UNKNOWN_REPLIES[slot]) return UNKNOWN_REPLIES[slot];
  return FLOW8_REPLIES[slot] || [];
}

export function rowsFor(item) {
  if (item === "pythagore") {
    return [
      ["Matière", "Maths"],
      ["Thème", "Pythagore"],
      ["Figure", "Triangle rectangle"],
      ["Côté a", "3 cm"],
      ["Côté b", "4 cm"],
    ];
  }
  if (item === "phrase") {
    return [
      ["Matière", "Français"],
      ["Thème", "La phrase"],
      ["Phrase", "Le petit chat noir dort"],
      ["À trouver", "Le sujet et le verbe"],
    ];
  }
  if (item === "unknown") {
    return [
      ["Matière", "Pas reconnue"],
      ["Thème", "Page hors exemple"],
      ["Pages connues", "Sondage, triangle, phrase"],
    ];
  }
  return EXTRACT_ROWS;
}

export function tableFor(item) {
  if (item === "pythagore") {
    return {
      title: "Les deux côtés de l'angle droit",
      subtitle: "On élève chaque longueur au carré",
      rows: [
        ["3 cm", "3² = 9"],
        ["4 cm", "4² = 16"],
      ],
    };
  }
  if (item === "phrase") {
    return {
      title: "Groupes de la phrase",
      subtitle: "Le petit chat noir dort sur le canapé",
      rows: [
        ["Sujet", "Le petit chat noir"],
        ["Verbe", "dort"],
        ["Lieu", "sur le canapé"],
      ],
    };
  }
  return {
    title: "Selon le nombre d'élèves",
    subtitle: "Proportion observée : 30 %",
    rows: MARGIN_ROWS,
  };
}

function result(messages, quickReplies, flowStep, planReady = false) {
  return {
    messages,
    quickReplies,
    flowStep,
    status: FLOW8_STEPS[flow8DisplayIndex(flowStep)],
    planReady,
  };
}

/** Instant history for a sommaire step (display index 0–4). */
export function buildFlow8Snapshot(displayIndex) {
  const step = Math.min(Math.max(displayIndex, 0), FLOW8_STEPS.length - 1);
  const messages = [{ sender: "agent", messageKey: "f8.ask", text: ASK_MESSAGE }];
  if (step === 0) return result(messages, FLOW8_REPLIES.ask, 0);

  messages.push({ sender: "user", kind: "photo" });
  messages.push({ sender: "agent", messageKey: "f8.read", text: READ_MESSAGE });
  messages.push({ sender: "agent", kind: "extract" });
  messages.push({ sender: "agent", messageKey: "f8.prompt", text: PROMPT_MESSAGE });
  if (step === 1) return result(messages, FLOW8_REPLIES.read, 1);

  messages.push({ sender: "user", text: "Je ne comprends pas" });
  messages.push({ sender: "agent", messageKey: "f8.idea", text: IDEA_MESSAGE });
  messages.push({ sender: "agent", kind: "margins" });
  messages.push({ sender: "agent", messageKey: "f8.curve", text: CURVE_MESSAGE });
  if (step === 2) return result(messages, FLOW8_REPLIES.choice, 2);

  messages.push({ sender: "user", text: "B. Interroger plus de personnes" });
  messages.push({ sender: "agent", messageKey: "f8.exact", text: EXACT_MESSAGE });
  messages.push({ sender: "user", text: "C'est le calcul et la formule" });
  messages.push({ sender: "agent", messageKey: "f8.formula", text: FORMULA_MESSAGE });
  messages.push({ sender: "agent", kind: "calc" });
  messages.push({ sender: "agent", messageKey: "f8.try", text: TRY_MESSAGE });
  messages.push({ sender: "user", text: "0,000525" });
  messages.push({ sender: "agent", messageKey: "f8.divOk", text: DIV_OK });
  messages.push({ sender: "agent", messageKey: "f8.fiche", text: FICHE_MESSAGE });
  messages.push({ sender: "agent", kind: "fiche" });
  messages.push({ sender: "agent", messageKey: "f8.after", text: AFTER_MESSAGE });
  if (step === 3) return result(messages, FLOW8_REPLIES.after, 6, true);

  messages.push({ sender: "user", text: "J'ai compris" });
  messages.push({ sender: "agent", messageKey: "f8.understood", text: UNDERSTOOD_MESSAGE });
  return result(messages, [], 8, true);
}
